import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { UseFlowCategoriesRepository } from '../types';

const defaultSqlAutomations = {
  ids: [],
  byId: {},
  total: 0,
  error: null,
  loading: false,
  meta: { currentPage: 1, totalPages: 1, totalItems: 0 },
};

function useFlowCategoriesRepository(): UseFlowCategoriesRepository {
  const flowCategories = useSelector((state: any) => state.flowCategories);

  const getFlowsWithoutProjects = useCallback(() => {
    return (
      flowCategories?.withoutProjects || {
        ids: [],
        total: 0,
        error: null,
        loading: false,
      }
    );
  }, [flowCategories?.withoutProjects]);

  const getTotalFlowWithoutProjects = useCallback(() => {
    return flowCategories?.withoutProjects?.total || 0;
  }, [flowCategories?.withoutProjects?.total]);

  const getFlowsSqlAutomations = useCallback(() => {
    return flowCategories?.sqlAutomations || defaultSqlAutomations;
  }, [flowCategories?.sqlAutomations]);

  return {
    flowCategories,
    getFlowsWithoutProjects,
    getTotalFlowWithoutProjects,
    getFlowsSqlAutomations,
  };
}

export { useFlowCategoriesRepository };
